import { render, staticRenderFns } from "./TermosUsoPoliticas.vue?vue&type=template&id=46393686&"
import script from "./TermosUsoPoliticas.vue?vue&type=script&lang=js&"
export * from "./TermosUsoPoliticas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports